export var UnsupportedZip = {
  US: ['11111', '00000'],
  // US territories
  UM: ['11111', '00000'],
  AS: ['11111', '00000'],
  GU: ['11111', '00000'],
  MP: ['11111', '00000'],
  PR: ['11111', '00000'],
  VI: ['11111', '00000']
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/constants/UnsupportedZip.js
// module id = 4422
// module chunks = 11